import { ORIGINAL_AUDIO_MANIFEST } from "../data/generated/original-audio-manifest";

export const ORIGINAL_AUDIO_RUNTIME_CONSUMPTION = {
  manifest: "docs/original-audio-manifest.json",
  generatedManifestModule: "web/src/data/generated/original-audio-manifest.ts",
  consumesDecodedAudio: true,
  sourceBackedStatus: ORIGINAL_AUDIO_MANIFEST.status,
  sourceBackedCriteria: {
    bgmApiProceduresDecoded: ORIGINAL_AUDIO_MANIFEST.criteria.bgmApiProceduresDecoded,
    soundApiProcedureDecoded: ORIGINAL_AUDIO_MANIFEST.criteria.soundApiProcedureDecoded,
    battleBgmSelectionDecoded: ORIGINAL_AUDIO_MANIFEST.criteria.battleBgmSelectionDecoded,
    soundEffectCallMappingDecoded: ORIGINAL_AUDIO_MANIFEST.criteria.soundEffectCallMappingDecoded,
    webSoundEffectAssetsByteIdentical: ORIGINAL_AUDIO_MANIFEST.criteria.webSoundEffectAssetsByteIdentical,
    midiToWebAudioEquivalenceScopedToReferenceAssetPolicy:
      ORIGINAL_AUDIO_MANIFEST.criteria.midiToWebAudioEquivalenceScopedToReferenceAssetPolicy,
    messageAudioCommandHandlerScopedToMessageEffectsGate:
      ORIGINAL_AUDIO_MANIFEST.criteria.messageAudioCommandHandlerScopedToMessageEffectsGate,
    missingOrFallbackAudioPolicyDecoded: ORIGINAL_AUDIO_MANIFEST.criteria.missingOrFallbackAudioPolicyDecoded
  }
} as const;

export function originalAudioRuntimeConsumesDecodedAudio(): boolean {
  return ORIGINAL_AUDIO_RUNTIME_CONSUMPTION.consumesDecodedAudio;
}

export function originalBgmRuntimeAsset(
  requestedBgm: string,
  webBgmFiles: Record<string, string>
): string | undefined {
  return webBgmFiles[requestedBgm.toUpperCase()];
}

const ORIGINAL_WAV_ASSETS = ORIGINAL_AUDIO_MANIFEST.originalAssets.wav.map((asset) => asset.name);
const ORIGINAL_WAV_BY_UPPER = new Map(ORIGINAL_WAV_ASSETS.map((asset) => [asset.toUpperCase(), asset]));
const ORIGINAL_WAV_BY_STEM = new Map(
  ORIGINAL_WAV_ASSETS.map((asset) => [asset.replace(/\.wav$/i, "").toUpperCase(), asset])
);

export function originalSoundEffectRuntimeAsset(name: string): string {
  const normalized = name.trim().replace(/^["']|["']$/g, "");
  if (!normalized) return normalized;
  const withExtension = /\.wav$/i.test(normalized) ? normalized : `${normalized}.WAV`;
  return ORIGINAL_WAV_BY_UPPER.get(withExtension.toUpperCase()) ?? ORIGINAL_WAV_BY_STEM.get(normalized.toUpperCase()) ?? withExtension;
}
